import React from 'react'
import { Tooltip } from '@mui/material'
import { useFactoringData } from 'hooks/useFactoringData'
import { abbreviateRating } from '@numeo/types'

/** Compact factoring badge for the table Company column (shown after first expand). */
export const FactoringBadge: React.FC<{ mcNumber: string | null }> = ({ mcNumber }) => {
    const { displayData, isLoading, authError, selectedProvider } = useFactoringData(mcNumber)

    if (!mcNumber || isLoading || authError || displayData.rating === '–') return null

    const providerLabel = selectedProvider?.toUpperCase() || ''
    const { abbrev, color: derivedColor } = abbreviateRating(displayData.rating)
    const color = displayData.color || derivedColor

    // Tooltip: "TAFS Rating: Approved For Purchases • 96.38 · 14d pay"
    let tooltipText = `${providerLabel} Rating: ${displayData.rating}`
    if (displayData.loadsCount) tooltipText += ` • ${displayData.loadsCount}`
    if (displayData.daysToPay) tooltipText += ` · ${displayData.daysToPay}d pay`

    return (
        <Tooltip title={tooltipText} arrow placement="top">
            <span
                className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[9px] font-bold text-white flex-shrink-0 tabular-nums"
                style={{ backgroundColor: color }}
            >
                {abbrev}
                {displayData.loadsCount && (
                    <>
                        <span className="w-px h-2.5 bg-white/40" />
                        <span className="font-semibold">{displayData.loadsCount}</span>
                    </>
                )}
            </span>
        </Tooltip>
    )
}
